import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {Modal} from "../../../../../../services/modal.service";
import {Api, ApiService} from "../../../../../../../common/services/api.service";
import {SpinnerService} from "../../../../../../../common/services/spinner.service";

@Component({
    selector: "section-pm-kit-stock",
    templateUrl: "stock.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PartMasterKitStockComponent implements OnInit {

    public modal: Modal.IModal;

    public item: string = "";

    public rows: { hub_id: number, hub: string, buildable: number }[] = [];

    public loaded: boolean = false;

    public constructor(
        private apiService: ApiService,
        private spinnerService: SpinnerService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
    }

    private async getStock(): Promise<any> {
        this.spinnerService.show();
        const {data}: Api.IResponse = await this.apiService.request(Api.EMethod.Get,
            ["partmaster", "kits", "" + this.modal.params.part_master.id, "stock"]);
        this.rows = data || [];
        this.loaded = true;
        this.changeDetectorRef.markForCheck();
        this.spinnerService.hide();
    }

    public ngOnInit(): void {
        this.item = this.modal.params.part_master ? this.modal.params.part_master.item : "";
        this.getStock();
    }

}
